<div class="agt-dashboard" *transloco="let t; prefix: 'atgDashboard'">

  <div class="dashboard-top-section d-flex align-items-center justify-content-between">
    <h1>{{ t('title') }}</h1>

    <div class="search-menu-lists d-flex">
      <div class="datelisting all-account">
        <div class="common-drop-down dropdown">
          <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdown-button" data-bs-toggle="dropdown"
            aria-expanded="false">
            {{ t('filters.allAccounts') }}
            <img src="/assets/images-fuel/arrowDownIcon.svg" alt="">
          </button>
          <ul class="dropdown-menu" aria-labelledby="dropdown-button">
            <li><a class="dropdown-item">{{ t('filters.account1') }}</a></li>
            <li><a class="dropdown-item">{{ t('filters.account2') }}</a></li>
            <li><a class="dropdown-item">{{ t('filters.account3') }}</a></li>
          </ul>
        </div>
      </div>
      <div class="datelisting all-atg">
        <div class="common-drop-down dropdown">
          <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdown-button" data-bs-toggle="dropdown"
            aria-expanded="false">
            {{ t('filters.allAtgDevices') }}
            <img src="/assets/images-fuel/arrowDownIcon.svg" alt="">
          </button>
          <ul class="dropdown-menu" aria-labelledby="dropdown-button">
            <li><a class="dropdown-item">{{ t('filters.device1') }}</a></li>
            <li><a class="dropdown-item">{{ t('filters.device2') }}</a></li>
            <li><a class="dropdown-item">{{ t('filters.device3') }}</a></li>
          </ul>
        </div>
      </div>
      <div class="datelisting">
        <div class="common-drop-down dropdown">
          <app-date-filter [filter]="utilizationDateFilter" [isButtonIntervalSelector]="false"
            [disabledIntervals]="disabledIntervals" [disableCustomDateSelector]="false"
            [defaultInterval]="defaultInterval" (filterChanged)="onUtilizationDateFilterChange($event)">
          </app-date-filter>
        </div>
      </div>
    </div>
  </div>

  <div class="row atg-card-row">
    <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12">
      <app-dashboard-card [cardInfo]="{
          title: t('cards.totalFuel'),
          iconImg: 'assets/images-fuel/fuelPumpIcon.svg',
          iconImg2: 'assets/images-fuel/increaseIcon.svg',
          percentage: '+3.12%',
          isSelect: false,
          status: '28 ℓ',
          shareStatus: 'increase',
          isFooter: false
        }"></app-dashboard-card>
    </div>
    <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12">
      <app-dashboard-card [cardInfo]="{
          title: t('cards.totalLoss'),
          iconImg: 'assets/images-fuel/fuelConIcon.svg',
          iconImg2: 'assets/images-fuel/decreaseIcon.svg',
          percentage: '+3.12%',
          isSelect: false,
          status: '28 ℓ',
          shareStatus: 'decrease',
          isFooter: false
        }"></app-dashboard-card>
    </div>
    <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12">
      <app-dashboard-card [cardInfo]="{
          title: t('cards.matchedPercentage'),
          iconImg: 'assets/images-fuel/matchIcon.svg',
          iconImg2: 'assets/images-fuel/decreaseIcon.svg',
          percentage: '+1.1%',
          isSelect: false,
          status: '90 %',
          shareStatus: 'decrease',
          isFooter: false
        }"></app-dashboard-card>
    </div>
    <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12">
      <app-dashboard-card [cardInfo]="{
          title: t('cards.totalValue'),
          iconImg: 'assets/images-fuel/valueIcon.svg',
          iconImg2: 'assets/images-fuel/decreaseIcon.svg',
          percentage: '+3.12%',
          isSelect: false,
          status: 'R 250K',
          shareStatus: 'decrease',
          isFooter: false
        }"></app-dashboard-card>
    </div>
  </div>

  <div class="button-wrapper">
    <div class="button-left-wrapper">
      <div class="tank-card">
        <div class="row">
          @for(item of tankCard; track $index){
          <div class="col-lg-3 col-md-6 col-sm-6 tank_card-col" [id]="'__' + item._id">
            <app-tank-card [tankInfo]="item" [tankNo]="$index + 1"></app-tank-card>
          </div>
          }
        </div>
      </div>
      <div class="table-wrappper">
        <!-- <app-common-table [modalType]="'atg-dashboard-table'" /> -->
        <div class="main-table atg-dshbord-table">
          <table class="table">
            <thead>
              <tr>
                <th class="time">
                  {{ t('table.timeOfDrop') }}<button class="filter-button">
                    <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                  </button>
                </th>
                <th class="litre">{{ t('table.litresDecreased') }}</th>
                <th class="match">{{ t('table.matchedVehicle') }}</th>
                <th class="status">
                  {{ t('table.status') }}<button class="filter-button">
                    <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                  </button>
                </th>
                <th class="type">
                  {{ t('table.type') }}<button class="filter-button">
                    <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                  </button>
                </th>
                <th class="time-stamp">
                  {{ t('table.timeStamp') }}<button class="filter-button">
                    <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                  </button>
                </th>
                <th class="variance">
                  {{ t('table.variance') }}<button class="filter-button">
                    <img src="assets/images-fuel/filterIconMainTable.svg" alt="filter-btn" />
                  </button>
                </th>
              </tr>
            </thead>
            <tbody>
              @for (row of mockRows; track $index) {
              <tr>
                <td class="time">
                  <p>{{ row.time }}</p>
                </td>
                <td class="litre">
                  <p>{{ row.litres }}</p>
                </td>
                <td class="match">
                  <p>{{ row.asset }}</p>
                </td>
                <td class="status">
                  <span [class]="'chip ' + row.chip"><img [src]="'assets/images-fuel/' + row.icon" alt="icon" />{{ t('table.statuses.' + row.status) }}</span>
                </td>
                <td class="type">
                  <p>{{ t('table.types.' + row.type) }}</p>
                </td>
                <td class="time-stamp">
                  <p>{{ row.timestamp }}</p>
                </td>
                <td class="variance">
                  <span [class]="'chip ' + row.chip"><img [src]="'assets/images-fuel/' + row.icon" alt="icon" />{{ row.variance }}</span>
                </td>
              </tr>
              }
            </tbody>
          </table>
        </div>
        
        <div class="d-flex align-items-center justify-content-between bottom-options">
          <p class="pageination-text">{{ 'common.showingOutOf' | transloco: { current: 4, total: 12 } }}</p>
          <nav [attr.aria-label]="t('pagination.navigation')">
            <ul class="pagination">
              <li class="page-item">
                <a class="page-link" [attr.aria-label]="t('pagination.previous')">
                  <span aria-hidden="true"><i><img src="./assets/images-fuel/arrow-left-pagination.svg"
                        alt="icon-arrow" /></i></span>
                </a>
              </li>
              <li class="page-item active-pagination">
                <a class="page-link">1</a>
              </li>
              <li class="page-item"><a class="page-link">2</a></li>
              <li class="page-item"><a class="page-link">3</a></li>
              <li class="page-item">
                <a class="page-link" [attr.aria-label]="'common.next' | transloco">
                  <span aria-hidden="true"><i><img src="./assets/images-fuel/arrow-btn-pagination.svg"
                        alt="icon-arrow" /></i></span>
                </a>
              </li>
            </ul>
          </nav>
          <div class="export-listing">
            <div class="common-drop-down dropdown">
              <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdown-button" data-bs-toggle="dropdown"
                aria-expanded="false">
                {{ t('export.label') }} <i><img src="./assets/images-fuel/downloadIcon.svg" alt="export-icon" /></i>
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdown-button">
                <li><a class="dropdown-item">{{ t('export.asPdf') }}</a></li>
                <li><a class="dropdown-item">{{ t('export.asCsv') }}</a></li>
                <li><a class="dropdown-item">{{ t('export.sendViaEmail') }}</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bottom-section-wrap-right">
      <app-common-map></app-common-map>
    </div>
  </div>